import React, { useRef, useState, useEffect } from "react";
import { Link, Navigate, useLocation, useNavigate, useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";

import axiosInstance from "../../axiosInstance";

import { Pagination, Navigation, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useBlogContext } from "../../fetchdata/BlogContext";
import Select from 'react-select';
import CreateSlug from "../components/extra/CreateSlug";
import NavBar from "../components/NavBar";


const Home = () => {


  const {

    isLayoutLoading,
    layout, splashScreen, AllHomeProducts, isProducts, Headers, IsBlogLoading, AllBlogs, AllCategoriess, LocationHeaders
  } = useBlogContext();




  useEffect(() => {
    window.scrollTo(0, 0);
    console.log('HeadersHeaders', Headers.gold, Headers.sliver)
  }, []);


  const swiperRef = useRef();

  const swiperRefLocal = useRef();

  const handleMouseEnter = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.stop();
  };

  const handleMouseLeave = () => {
    swiperRefLocal?.current?.swiper?.autoplay?.start();
  };


  const [formData, setFormData] = useState({});


  //   const filteredLocations = LocationHeaders.filter((location) =>
  //   location.toLowerCase().includes(searchQuery.toLowerCase())
  // );



  const navigate = useNavigate();


  const [goldRates, setGoldRates] = useState({});
  const [silverPrice, setSilverPrice] = useState(null);

  useEffect(() => {
    // Instead of API
    const gold10gm = Headers.gold;     // 24KT price for 10gm
    const silver10gm = Headers.sliver; // Silver price for 10gm

    // Convert 10gm → 1gm
    const goldPerGram = gold10gm / 10;
    const silverPerGram = silver10gm / 10;

    setGoldRates({
      "24KT": goldPerGram,
      "22KT": goldPerGram * (22 / 24),
      "18KT": goldPerGram * (18 / 24),
      "14KT": goldPerGram * (14 / 24),
    });

    setSilverPrice(silverPerGram);
  }, [Headers]);



  const [Products, setProducts] = useState([]);

  const getProducts = async () => {
    try {
      const { data } = await axiosInstance.get("/all-home-products");
      console.log("products", data);
      setProducts(data.products);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    getProducts();
  }, []);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const timer = setTimeout(() => {
        const element = document.querySelector(location.hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 200); // ⏱ 1 second delay

      return () => clearTimeout(timer);
    }
  }, [location]);


  const isVideo = (url) => /\.(mp4|webm|ogg)$/i.test(url);


  return (
    <>


      <Header />


      <main className="page-content  mypadding bg-light overflow-auto  px-0"  >


        <div className="py-4 position-relative mb-3" onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave} style={{ zIndex: 2 }} >
          <Swiper
            slidesPerView={1}
            spaceBetween={30}
            pagination={{
              clickable: true,
            }}
            navigation={false}
            breakpoints={{
              300: {
                slidesPerView: 1,
              },
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 1.2,
              },
              1024: {
                slidesPerView: 1.2,
              },
            }}
            ref={swiperRefLocal}
            autoplay={{
              delay: 2000,
              pauseOnMouseEnter: true,
            }}

            loop={true}
            centeredSlides={true}
            modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 align-items-center" >

            {isLayoutLoading
              ? Array.from({ length: 4 }).map((_, index) => (
                <SwiperSlide
                  className="skeleton rounded-4"
                  style={{
                    width: "100%",
                    aspectRatio: "1800/675"
                  }}
                ></SwiperSlide>
              ))
              : (
                <>

                  {layout.home_slider && (
                    <>
                      {layout.home_slider.map((image, index) => (

                        <SwiperSlide key={index}
                          className="skeleton rounded-4"
                          style={{
                            width: "100%",
                            aspectRatio: "1800/675"
                          }} >
                          <div className="link-dark">
                            <img
                              className="img-fluid w-100 rounded-4"
                              src={image}
                              alt="Preview"
                              id={`imageinputN1${index + 1}`}
                            />
                          </div>
                        </SwiperSlide>


                      ))}
                    </>
                  )}


                </>
              )}


          </Swiper>
        </div>



        <section className="content-inner bg-light pt-4 pb-4">
          <div className="container">
            {/* Heading */}
            <div className="section-head style-1 text-start">
              <div className="max-w900">
                <h2 className="title">
                  Shop By Categories
                </h2>
              </div>
            </div>

            {/* Slider */}
            <div
              className="p-0 position-relative mt-3"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={{ zIndex: 2 }}
            >
              <Swiper
                slidesPerView={2.8}
                spaceBetween={12}
                autoplay={{
                  delay: 1000,
                  pauseOnMouseEnter: true,
                }}
                navigation={true}
                loop
                breakpoints={{
                  300: { slidesPerView: 2.8 },
                  640: { slidesPerView: 2.8 },
                  768: { slidesPerView: 3.5 },
                  1024: { slidesPerView: 6 },
                }}
                modules={[Autoplay, Navigation]}

                className="product-style1"
              >
                {isLayoutLoading ? (
                  Array.from({ length: 6 }).map((_, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="skeleton"
                        style={{
                          aspectRatio: "1/1",
                          borderRadius: "12px",
                        }}
                      />
                    </SwiperSlide>
                  ))
                ) : (
                  layout?.trending_product_banner?.map((item, index) => (
                    <SwiperSlide key={index}>
                      <Link to={item?.imageUrlInput}>
                        <div className="image-box style-1 text-center">
                          <div className="dz-media">
                            <img
                              src={item?.imageInput}
                              alt={item?.imageTITInput}
                              className="img-fluid"
                            />
                            <div className="item">
                              {item?.itemCount || "View"}
                            </div>
                          </div>
                          <h3 className="title mt-2">
                            {item?.imageTITInput}
                          </h3>
                        </div>
                      </Link>
                    </SwiperSlide>
                  ))
                )}
              </Swiper>
            </div>
          </div>
        </section>


        <section className="px-2 mb-3 d-none">
          <div className="bg-primary rounded overflow-hidden" onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave} style={{ zIndex: 2 }} >
            <Swiper
              slidesPerView={1}
              spaceBetween={30}

              navigation={true}
              breakpoints={{
                300: {
                  slidesPerView: 1,
                },
                640: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1,
                },
              }}
              ref={swiperRefLocal}
              autoplay={{
                delay: 1500,
                pauseOnMouseEnter: true,
              }}
              loop={true}
              modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 ">

              {isLayoutLoading && !Headers
                ? Array.from({ length: 4 }).map((_, index) => (
                  <SwiperSlide
                    className="skeleton"
                    style={{
                      width: "100%",
                      aspectRatio: "552/88"
                    }}
                  ></SwiperSlide>
                ))
                :
                <>


                  <SwiperSlide className="">
                    <div className="d-flex">
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'gold' }} />
                            Current Gold Rate   </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Gold 24KT:</strong> ₹{goldRates["24KT"] ? Math.floor(goldRates["24KT"]) : "Loading..."} </p>
                        </div>
                      </div>
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'gold' }} />
                            Current Gold Rate   </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Gold 22KT:</strong> ₹{goldRates["22KT"] ? Math.floor(goldRates["22KT"]) : "Loading..."} </p>
                        </div>
                      </div>

                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="">
                    <div className="d-flex">
                      {/* Gold 24KT */}
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'gold' }} />
                            Current Gold Rate
                          </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Gold 24KT:</strong> ₹{goldRates["24KT"] ? Math.floor(goldRates["24KT"]) : "Loading..."}</p>
                        </div>
                      </div>

                      {/* Gold 22KT */}
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'gold' }} />
                            Current Gold Rate
                          </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Gold 22KT:</strong> ₹{goldRates["22KT"] ? Math.floor(goldRates["22KT"]) : "Loading..."}</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="">
                    <div className="d-flex">

                      {/* Gold 18KT */}
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'gold' }} />
                            Current Gold Rate
                          </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Gold 18KT:</strong> ₹{goldRates["18KT"] ? goldRates["18KT"].toFixed(2) : "Loading..."}</p>
                        </div>
                      </div>

                      {/* Gold 14KT */}
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'gold' }} />
                            Current Gold Rate
                          </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Gold 14KT:</strong> ₹{goldRates["14KT"] ? goldRates["14KT"].toFixed(2) : "Loading..."}</p>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide className="">
                    <div className="d-flex">

                      {/* Silver */}
                      <div className="col text-white" style={{ borderRight: '0.1px solid white' }}>
                        <div className="px-2">
                          <p className="m-0 p-0 pt-2 text-center">
                            <i className="ri-coin-fill me-2 " style={{ color: 'silver' }} />
                            Silver Price
                          </p>
                        </div>
                        <div className="py-2" style={{ borderBottom: '0.5px solid white' }} />
                        <div className="px-2 pt-2 text-center">
                          <p><strong>Silver:</strong> ₹{silverPrice ? silverPrice.toFixed(2) : "Loading..."}</p>
                        </div>
                      </div>


                    </div>
                  </SwiperSlide>



                </>
              }


            </Swiper>
          </div>
        </section>





        <section className="my-4">

          {isLayoutLoading
            ? Array.from({ length: 4 }).map((_, index) => (
              <div
                className="skeleton"
                style={{
                  width: "100%",
                  aspectRatio: "197/90"
                }}
              ></div>
            ))
            : (
              <>

                {layout.trending_product_carousal && (
                  <>
                    {layout.trending_product_carousal.map((image, index) => (

                      <img key={index} src={image?.imageInput} className="d-block w-100 mb-4" alt="banner" />


                    ))}
                  </>
                )}

              </>)}




        </section>


        <section className="content-inner bg-light pt-4 mt-2 pb-4">
          <div className="container">
            {/* Heading */}
            <div className="section-head style-1 text-start mb-4">
              <div className="max-w900">
                <h2 className="title">
                  Trending Product
                </h2>
              </div>
            </div>


            <div className="row pt-0 mx-0 hero-swiper hide-desk-arrow">
              {/* Product Card */}
              <Swiper
                breakpoints={{
                  300: {
                    slidesPerView: 2,
                    spaceBetween: 10, // Set the gap between slides for window width <= 400px
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 20, // Set the gap between slides for window width <= 768px
                  },
                  992: {
                    slidesPerView: 4,
                    spaceBetween: 25, // Set the gap between slides for window width <= 992px
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 20, // Set the gap between slides for window width <= 1200px
                  },
                }}
                pagination={true}
                modules={[Pagination, Navigation]}
                className="swiper-wrapper"
              >
                {isProducts
                  ? Array.from({ length: 7 }).map((_, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="card-1 skeleton"
                        style={{ height: 371, borderRadius: 10 }}
                      ></div>
                    </SwiperSlide>
                  ))
                  : layout.trending_product && (
                    <>
                      {Products.map((product, index) => {

                        return (
                          layout.trending_product.includes(product._id) && (
                            <>
                              <SwiperSlide key={index}>
                                <>


                                  <div className="shop-card rounded-4 shadow-sm">
                                    <div className="dz-media media-overlay">
                                      <div className="dz-media media-overlay">
                                        {isVideo(product.pImage) ? (
                                          <video
                                            src={product.pImage}
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            className="img-fluid w-100"
                                            style={{ objectFit: "cover" }}
                                          />
                                        ) : (
                                          <img
                                            className="img-fluid"
                                            src={product.pImage}
                                            alt={`${product.title} Product Image`}
                                          />
                                        )}
                                      </div>

                                      <div className="shop-meta">
                                        <Link
                                          to={`/product/${product.slug}`}
                                          className="btn btn-secondary btn-icon"

                                        >
                                          <i className="fa-solid fa-eye d-md-none d-block" />
                                          <span className="d-md-block d-none">Quick View</span>
                                        </Link>
                                        <div className="btn btn-primary meta-icon dz-carticon">
                                          <svg
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M20.531 5.47097L17.531 2.47097C17.238 2.17797 16.763 2.17797 16.47 2.47097C16.177 2.76397 16.177 3.23897 16.47 3.53197L18.19 5.25197H6.00098C4.48398 5.25197 3.25098 6.48497 3.25098 8.00197V11.001C3.25098 11.415 3.58698 11.751 4.00098 11.751C4.41498 11.751 4.75098 11.415 4.75098 11.001V8.00197C4.75098 7.31297 5.31198 6.75197 6.00098 6.75197H18.19L16.47 8.47197C16.177 8.76497 16.177 9.23997 16.47 9.53297C16.616 9.67897 16.808 9.75297 17 9.75297C17.192 9.75297 17.384 9.67997 17.53 9.53297L20.53 6.53297C20.823 6.23997 20.823 5.76497 20.53 5.47197L20.531 5.47097Z"
                                              fill="black"
                                            />
                                            <path
                                              d="M18.9998 12.25C18.5858 12.25 18.2498 12.586 18.2498 13V15.999C18.2498 16.688 17.6888 17.249 16.9998 17.249H5.81075L7.53075 15.529C7.82375 15.236 7.82375 14.761 7.53075 14.468C7.23775 14.175 6.76275 14.175 6.46975 14.468L3.46975 17.468C3.17675 17.761 3.17675 18.236 3.46975 18.529L6.46975 21.529C6.61575 21.675 6.80775 21.749 6.99975 21.749C7.19175 21.749 7.38375 21.676 7.52975 21.529C7.82275 21.236 7.82275 20.761 7.52975 20.468L5.80975 18.748H16.9988C18.5158 18.748 19.7488 17.515 19.7488 15.998V12.999C19.7488 12.585 19.4128 12.249 18.9988 12.249L18.9998 12.25Z"
                                              fill="black"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="dz-content">
                                      <h5 className="title">
                                        <Link to={`/product/${product.slug}`} >Moisturizing Body Lotion</Link>
                                      </h5>
                                      <h6 className="price">
                                        ₹{product.salePrice} {' '}
                                        <del>₹{product.regularPrice}{" "}</del>
                                      </h6>
                                      <div className="shop-cart-btn">
                                        <Link to={`/product/${product.slug}`}>
                                          <svg
                                            width="30px"
                                            height="30px"
                                            viewBox="0 0 24 24"
                                            fill="white"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M6 18L18 6M18 6H9M18 6V15"
                                              stroke="white"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>

                                        </Link>
                                      </div>
                                    </div>
                                    <div className="product-tag">
                                      {/* <span className="badge-1">Get 20% Off</span> */}
                                      <Link to={`/product/${product.slug}`} className="badge-heart">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={20}
                                          height={20}
                                          viewBox="0 0 20 20"
                                          fill="none"
                                        >
                                          <path
                                            d="M17.3666 3.84172C16.941 3.41589 16.4356 3.0781 15.8794 2.84763C15.3232 2.61716 14.727 2.49854 14.1249 2.49854C13.5229 2.49854 12.9267 2.61716 12.3705 2.84763C11.8143 3.0781 11.3089 3.41589 10.8833 3.84172L9.99994 4.72506L9.1166 3.84172C8.25686 2.98198 7.0908 2.49898 5.87494 2.49898C4.65907 2.49898 3.49301 2.98198 2.63327 3.84172C1.77353 4.70147 1.29053 5.86753 1.29053 7.08339C1.29053 8.29925 1.77353 9.46531 2.63327 10.3251L3.5166 11.2084L9.99994 17.6917L16.4833 11.2084L17.3666 10.3251C17.7924 9.89943 18.1302 9.39407 18.3607 8.83785C18.5912 8.28164 18.7098 7.68546 18.7098 7.08339C18.7098 6.48132 18.5912 5.88514 18.3607 5.32893C18.1302 4.77271 17.7924 4.26735 17.3666 3.84172Z"
                                            stroke="black"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </Link>
                                    </div>
                                  </div>



                                </>

                                {/* Product Cards */}
                              </SwiperSlide >
                            </>
                          )
                        );
                      })}
                    </>
                  )}
              </Swiper>
            </div>

          </div>

        </section>

        <section className="content-inner bg-light pt-4 pb-4">
          <div className="container">

            <div className=" p-0 position-relative mt-3" onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave} style={{ zIndex: 2 }} >
              <Swiper
                slidesPerView={1}
                spaceBetween={12}
                pagination={false}
                navigation={false}
                breakpoints={{
                  300: {
                    slidesPerView: 2,
                  },
                  640: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                }}
                ref={swiperRefLocal}
                autoplay={{
                  delay: 1200,
                  pauseOnMouseEnter: true,
                }}
                loop={true}
                modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 ">

                {isLayoutLoading
                  ? Array.from({ length: 4 }).map((_, index) => (
                    <SwiperSlide
                      className="skeleton rounded"
                      style={{
                        width: "100%",
                        aspectRatio: "179/179",

                      }}
                    ></SwiperSlide>
                  ))
                  : (
                    <>

                      {layout.latest_product_banner && (
                        <>
                          {layout.latest_product_banner.map((image, index) => (


                            <SwiperSlide key={index} >

                              <Link to={image?.imageUrlInput} className="about-box">
                                <div className="about-img">
                                  <img src={image?.imageInput} alt="" class="w-100" />
                                </div>
                                <div className="about-btn d-none">
                                  <a className="btn btn-light btn-md" href="shop-list.html">
                                    {image?.imageTITInput}
                                  </a>
                                </div>
                              </Link>


                            </SwiperSlide>



                          ))}
                        </>
                      )}



                    </>
                  )}


              </Swiper>
            </div>

          </div>

        </section>


        <section className="content-inner bg-light pt-4 mt-2 pb-4">
          <div className="container">
            {/* Heading */}
            <div className="section-head style-1 text-start mb-4">
              <div className="max-w900">
                <h2 className="title">
                  Best Selling
                </h2>
              </div>
            </div>


            <div className="row pt-0 mx-0 hero-swiper hide-desk-arrow">
              {/* Product Card */}
              <Swiper
                breakpoints={{
                  300: {
                    slidesPerView: 2,
                    spaceBetween: 10, // Set the gap between slides for window width <= 400px
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 20, // Set the gap between slides for window width <= 768px
                  },
                  992: {
                    slidesPerView: 4,
                    spaceBetween: 25, // Set the gap between slides for window width <= 992px
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 20, // Set the gap between slides for window width <= 1200px
                  },
                }}
                pagination={true}
                modules={[Pagination, Navigation]}
                className="swiper-wrapper"
              >
                {isProducts
                  ? Array.from({ length: 7 }).map((_, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className="card-1 skeleton"
                        style={{ height: 371, borderRadius: 10 }}
                      ></div>
                    </SwiperSlide>
                  ))
                  : layout.best_selling_laptop && (
                    <>
                      {Products.map((product, index) => {

                        return (
                          layout.best_selling_laptop.includes(product._id) && (
                            <>
                              <SwiperSlide key={index}>
                                <>

                                  <div className="shop-card rounded-4 shadow-sm">
                                    <div className="dz-media media-overlay">
                                      <div className="dz-media media-overlay">
                                        {isVideo(product.pImage) ? (
                                          <video
                                            src={product.pImage}
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                            className="img-fluid w-100"
                                            style={{ objectFit: "cover" }}
                                          />
                                        ) : (
                                          <img
                                            className="img-fluid"
                                            src={product.pImage}
                                            alt={`${product.title} Product Image`}
                                          />
                                        )}
                                      </div>

                                      <div className="shop-meta">
                                        <Link
                                          to={`/product/${product.slug}`}
                                          className="btn btn-secondary btn-icon"

                                        >
                                          <i className="fa-solid fa-eye d-md-none d-block" />
                                          <span className="d-md-block d-none">Quick View</span>
                                        </Link>
                                        <div className="btn btn-primary meta-icon dz-carticon">
                                          <svg
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M20.531 5.47097L17.531 2.47097C17.238 2.17797 16.763 2.17797 16.47 2.47097C16.177 2.76397 16.177 3.23897 16.47 3.53197L18.19 5.25197H6.00098C4.48398 5.25197 3.25098 6.48497 3.25098 8.00197V11.001C3.25098 11.415 3.58698 11.751 4.00098 11.751C4.41498 11.751 4.75098 11.415 4.75098 11.001V8.00197C4.75098 7.31297 5.31198 6.75197 6.00098 6.75197H18.19L16.47 8.47197C16.177 8.76497 16.177 9.23997 16.47 9.53297C16.616 9.67897 16.808 9.75297 17 9.75297C17.192 9.75297 17.384 9.67997 17.53 9.53297L20.53 6.53297C20.823 6.23997 20.823 5.76497 20.53 5.47197L20.531 5.47097Z"
                                              fill="black"
                                            />
                                            <path
                                              d="M18.9998 12.25C18.5858 12.25 18.2498 12.586 18.2498 13V15.999C18.2498 16.688 17.6888 17.249 16.9998 17.249H5.81075L7.53075 15.529C7.82375 15.236 7.82375 14.761 7.53075 14.468C7.23775 14.175 6.76275 14.175 6.46975 14.468L3.46975 17.468C3.17675 17.761 3.17675 18.236 3.46975 18.529L6.46975 21.529C6.61575 21.675 6.80775 21.749 6.99975 21.749C7.19175 21.749 7.38375 21.676 7.52975 21.529C7.82275 21.236 7.82275 20.761 7.52975 20.468L5.80975 18.748H16.9988C18.5158 18.748 19.7488 17.515 19.7488 15.998V12.999C19.7488 12.585 19.4128 12.249 18.9988 12.249L18.9998 12.25Z"
                                              fill="black"
                                            />
                                          </svg>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="dz-content">
                                      <h5 className="title">
                                        <Link to={`/product/${product.slug}`} >Moisturizing Body Lotion</Link>
                                      </h5>
                                      <h6 className="price">
                                        ₹{product.salePrice} {' '}
                                        <del>₹{product.regularPrice}{" "}</del>
                                      </h6>
                                      <div className="shop-cart-btn">
                                        <Link to={`/product/${product.slug}`}>
                                          <svg
                                            width="30px"
                                            height="30px"
                                            viewBox="0 0 24 24"
                                            fill="white"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M6 18L18 6M18 6H9M18 6V15"
                                              stroke="white"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                          </svg>

                                        </Link>
                                      </div>
                                    </div>
                                    <div className="product-tag">
                                      {/* <span className="badge-1">Get 20% Off</span> */}
                                      <Link to={`/product/${product.slug}`} className="badge-heart">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={20}
                                          height={20}
                                          viewBox="0 0 20 20"
                                          fill="none"
                                        >
                                          <path
                                            d="M17.3666 3.84172C16.941 3.41589 16.4356 3.0781 15.8794 2.84763C15.3232 2.61716 14.727 2.49854 14.1249 2.49854C13.5229 2.49854 12.9267 2.61716 12.3705 2.84763C11.8143 3.0781 11.3089 3.41589 10.8833 3.84172L9.99994 4.72506L9.1166 3.84172C8.25686 2.98198 7.0908 2.49898 5.87494 2.49898C4.65907 2.49898 3.49301 2.98198 2.63327 3.84172C1.77353 4.70147 1.29053 5.86753 1.29053 7.08339C1.29053 8.29925 1.77353 9.46531 2.63327 10.3251L3.5166 11.2084L9.99994 17.6917L16.4833 11.2084L17.3666 10.3251C17.7924 9.89943 18.1302 9.39407 18.3607 8.83785C18.5912 8.28164 18.7098 7.68546 18.7098 7.08339C18.7098 6.48132 18.5912 5.88514 18.3607 5.32893C18.1302 4.77271 17.7924 4.26735 17.3666 3.84172Z"
                                            stroke="black"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </Link>
                                    </div>
                                  </div>




                                </>

                                {/* Product Cards */}
                              </SwiperSlide >
                            </>
                          )
                        );
                      })}
                    </>
                  )}
              </Swiper>
            </div>

          </div>

          <div id="reviews" />
        </section>




        <section className="content-inner bg-light pt-5 pb-5" >
          <div className="container">
            <div className="section-head style-1 text-center mb-4">
              <h2 className="title">What Our Customers Say</h2>
              <p className="text-muted mb-0">
                Real reviews from our happy customers
              </p>
            </div>

            <Swiper
              slidesPerView={1}
              spaceBetween={20}
              loop={true}
              autoplay={{
                delay: 2500,
                pauseOnMouseEnter: true,
              }}
              breakpoints={{
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
              }}
              modules={[Autoplay]}
              className="review-swiper"
            >
              {[1, 2, 3, 4, 5].map((item, index) => (
                <SwiperSlide key={index}>
                  <div className="review-card h-100">
                    <div className="review-header d-flex align-items-center gap-3">
                      <img
                        src="https://i.pravatar.cc/150?img=12"
                        alt="user"
                        className="review-avatar"
                      />
                      <div>
                        <h5 className="mb-0">Arvind Das</h5>
                        <span className="text-muted small">Verified Customer</span>
                      </div>
                    </div>

                    <div className="review-rating my-2">
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star"></i>
                      <i className="fas fa-star-half-alt"></i>
                    </div>

                    <p className="review-text">
                      Amazing experience! The service quality and support were top-notch.
                      Highly recommended for everyone.
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </section>



        <section className="content-inner bg-light pt-4 pb-4">


          <div className="container">

            <div className="section-head style-1 text-start mb-4">
              <div className="max-w900">
                <h2 className="title"> All Blogs </h2>
              </div>
            </div>

            <div className=" p-0 position-relative mt-3" onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave} style={{ zIndex: 2 }} >
              <Swiper
                slidesPerView={1}
                spaceBetween={12}
                pagination={false}
                navigation={false}
                breakpoints={{
                  300: {
                    slidesPerView: 2,
                  },
                  640: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 3,
                  },
                  1024: {
                    slidesPerView: 4,
                  },
                }}
                ref={swiperRefLocal}
                autoplay={{
                  delay: 1200,
                  pauseOnMouseEnter: true,
                }}
                loop={true}
                modules={[Pagination, Navigation, Autoplay]} className="book-now pb-0 ">

                {isLayoutLoading
                  ? Array.from({ length: 4 }).map((_, index) => (
                    <SwiperSlide
                      className="skeleton rounded"
                      style={{
                        width: "100%",
                        aspectRatio: "179/179",

                      }}
                    ></SwiperSlide>
                  ))
                  : (
                    <>

                      {layout.how_works && (
                        <>
                          {layout.how_works.map((image, index) => (


                            <SwiperSlide key={index} >

                              <div className="blog-card">
                                <div className="blog-media">
                                  <img src={image?.icon} alt="" class="w-100" />
                                  <div className="post-date">12 July 2022</div>
                                </div>
                                <div className="blog-info">
                                  <h4 className="blog-title mb-0">
                                    <Link to={image?.paragraph} className="title-link multi-hvr">
                                      {image?.heading}
                                    </Link>
                                  </h4>
                                  <ul className="blog-share">
                                    <li>
                                      <a className="share-btn" href="javascript:void(0);">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <path
                                            d="M7 17L17 7"
                                            stroke="black"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                          <path
                                            d="M7 7H17V17"
                                            stroke="black"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          />
                                        </svg>
                                      </a>
                                      <ul className="blog-social-icon">
                                        <li>
                                          <a href="https://www.facebook.com/" target="_blank">
                                            <i className="fab fa-facebook-f" />
                                          </a>
                                        </li>
                                        <li>
                                          <a href="javascript:void(0);">
                                            <i className="fa-brands fa-x-twitter" />
                                          </a>
                                        </li>
                                        <li>
                                          <a href="javascript:void(0);">
                                            <i className="fab fa-instagram" />
                                          </a>
                                        </li>
                                        <li>
                                          <a href="javascript:void(0);">
                                            <i className="fa-brands fa-linkedin-in" />
                                          </a>
                                        </li>
                                      </ul>
                                    </li>
                                  </ul>
                                </div>
                              </div>




                            </SwiperSlide>



                          ))}
                        </>
                      )}



                    </>
                  )}


              </Swiper>
            </div>

          </div>
        </section>



        <div className="content-inner py-0 overlay-white-middle">
          <div className="container-fluid px-0">

            {/* Instagram Follow Box */}
            <a
              href="https://www.instagram.com"
              className="instagram-link"
              target="_blank"
              rel="noreferrer"
            >
              <div className="follow-link bg-white wow bounceIn" data-wow-delay="0.1s">
                <div className="follow-link-content">
                  <h4 className="title">On the Instagram</h4>
                  <p className="text">Follow @GSJ</p>
                </div>
              </div>
            </a>

            {/* Dynamic Images */}
            <div className="row gx-0">
              {layout && layout?.service_category_Images && layout?.service_category_Images.map((item, index) => (
                <div
                  key={index}
                  className="col-xl-2 col-lg-2 col-md-3 col-sm-2 col-3 wow fadeIn"
                  data-wow-delay={`${(index % 6 + 1) * 0.1}s`}
                >
                  <div className="insta-post dz-media dz-img-effect">
                    <a
                      href={item.imageUrlInput || "javascript:void(0);"}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img
                        src={item.imageInput}
                        alt={`instagram-${index + 1}`}
                        className="img-fluid"
                      />
                    </a>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>




        <Footer />

      </main >


    </>
  );
};

export default Home;
